(function () {
  var MAX_PAGES = 40;
  var RENDER_SCALE = 1;
  var pdfRenderCache = Object.create(null);
  var workerSrc = null;

  function getPdfLib() {
    return window.pdfjsLib || window['pdfjs-dist/build/pdf'];
  }

  function getPageFlipClass() {
    if (window.St && window.St.PageFlip) return window.St.PageFlip;
    if (window.PageFlip) return window.PageFlip;
    return null;
  }

  function waitForDeps(timeoutMs) {
    var start = Date.now();
    return new Promise(function (resolve, reject) {
      function tick() {
        if (getPdfLib() && getPageFlipClass()) {
          resolve();
          return;
        }
        if (Date.now() - start > timeoutMs) {
          reject(new Error('deps_timeout'));
          return;
        }
        setTimeout(tick, 50);
      }
      tick();
    });
  }

  function getWorkerSrc() {
    if (workerSrc) return workerSrc;
    var el = document.querySelector('[data-oleum-catalog-flipbook]');
    if (el) {
      workerSrc = el.getAttribute('data-pdf-worker') || '';
    }
    return workerSrc;
  }

  function setLoadingMessage(wrap, message) {
    var loadingEl = wrap.querySelector('[data-catalog-loading]');
    if (!loadingEl) return;
    var textEl = loadingEl.querySelector('p');
    if (textEl) textEl.textContent = message;
  }

  function renderPdfPagesProgressive(pdfUrl, onProgress) {
    if (pdfRenderCache[pdfUrl]) {
      return pdfRenderCache[pdfUrl];
    }

    var pdfjsLib = getPdfLib();
    pdfjsLib.GlobalWorkerOptions.workerSrc = getWorkerSrc();

    var promise = pdfjsLib
      .getDocument({ url: pdfUrl, withCredentials: false })
      .promise.then(function (pdf) {
        var total = Math.min(pdf.numPages, MAX_PAGES);
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var scale = RENDER_SCALE * dpr;
        var pages = new Array(total);

        function renderPage(num) {
          return pdf.getPage(num).then(function (page) {
            var viewport = page.getViewport({ scale: scale });
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d', { alpha: false });

            canvas.width = Math.floor(viewport.width);
            canvas.height = Math.floor(viewport.height);

            return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function () {
              pages[num - 1] = canvas.toDataURL('image/jpeg', 0.78);
              if (onProgress) onProgress(num, total, pages.filter(Boolean));
            });
          });
        }

        var chain = Promise.resolve();
        for (var i = 1; i <= total; i += 1) {
          chain = chain.then(renderPage.bind(null, i));
        }

        return chain.then(function () {
          return pages;
        });
      });

    pdfRenderCache[pdfUrl] = promise;
    return promise.catch(function (err) {
      delete pdfRenderCache[pdfUrl];
      throw err;
    });
  }

  function loadPdfImagesProgressive(wrap, onProgress) {
    var primary = wrap.getAttribute('data-pdf-url');
    var fallback = wrap.getAttribute('data-pdf-fallback');

    return renderPdfPagesProgressive(primary, onProgress).catch(function () {
      if (fallback && fallback !== primary) {
        return renderPdfPagesProgressive(fallback, onProgress);
      }
      throw new Error('pdf_load_failed');
    });
  }

  function setVisible(el, visible) {
    if (!el) return;
    el.hidden = !visible;
    el.classList.toggle('is-visible', visible);
    el.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function updateStatus(wrap) {
    var pageFlip = wrap.oleumPageFlip;
    var statusEl = wrap.querySelector('[data-catalog-status]');
    var prevBtn = wrap.querySelector('[data-catalog-prev]');
    var nextBtn = wrap.querySelector('[data-catalog-next]');

    if (!pageFlip || !statusEl) return;

    var current = pageFlip.getCurrentPageIndex() + 1;
    var total = pageFlip.getPageCount();

    if (total <= 0) {
      statusEl.textContent = '';
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }

    statusEl.textContent = 'Página ' + current + ' de ' + total;
    if (prevBtn) prevBtn.disabled = current <= 1;
    if (nextBtn) nextBtn.disabled = current >= total;
  }

  function showError(wrap) {
    wrap.dataset.catalogFlipbookLoading = '0';
    setVisible(wrap.querySelector('[data-catalog-loading]'), false);
    setVisible(wrap.querySelector('[data-catalog-shell]'), false);
    setVisible(wrap.querySelector('[data-catalog-error]'), true);
  }

  function showReady(wrap) {
    if (wrap.dataset.catalogFlipbookReady === '1') return;
    wrap.dataset.catalogFlipbookLoading = '0';
    wrap.dataset.catalogFlipbookReady = '1';
    setVisible(wrap.querySelector('[data-catalog-loading]'), false);
    setVisible(wrap.querySelector('[data-catalog-shell]'), true);
    setVisible(wrap.querySelector('[data-catalog-error]'), false);
    setLoadingMessage(wrap, 'Preparando el catálogo…');
    updateStatus(wrap);
  }

  function toggleFullscreen(stageEl, wrap) {
    if (!stageEl) return;

    if (document.fullscreenElement === stageEl || document.webkitFullscreenElement === stageEl) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }

    if (stageEl.requestFullscreen) stageEl.requestFullscreen();
    else if (stageEl.webkitRequestFullscreen) stageEl.webkitRequestFullscreen();
  }

  function syncFullscreenButtons(wrap) {
    var stageEl = wrap.querySelector('[data-catalog-stage]');
    var active =
      !!stageEl &&
      (document.fullscreenElement === stageEl || document.webkitFullscreenElement === stageEl);

    wrap.querySelectorAll('[data-catalog-fullscreen]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.textContent = active ? 'Salir' : 'Pantalla completa';
    });

    if (wrap.oleumPageFlip && wrap.oleumPageFlip.update) {
      wrap.oleumPageFlip.update();
    }
  }

  function bindControls(wrap) {
    var prevBtn = wrap.querySelector('[data-catalog-prev]');
    var nextBtn = wrap.querySelector('[data-catalog-next]');
    var stageEl = wrap.querySelector('[data-catalog-stage]');

    if (prevBtn && !prevBtn.dataset.bound) {
      prevBtn.dataset.bound = '1';
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (wrap.oleumPageFlip) {
          wrap.oleumPageFlip.flipPrev('bottom');
          window.setTimeout(function () {
            updateStatus(wrap);
          }, 80);
        }
      });
    }

    if (nextBtn && !nextBtn.dataset.bound) {
      nextBtn.dataset.bound = '1';
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (wrap.oleumPageFlip) {
          wrap.oleumPageFlip.flipNext('bottom');
          window.setTimeout(function () {
            updateStatus(wrap);
          }, 80);
        }
      });
    }

    if (stageEl && !wrap.dataset.fullscreenBound) {
      wrap.dataset.fullscreenBound = '1';

      wrap.querySelectorAll('[data-catalog-fullscreen]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          toggleFullscreen(stageEl, wrap);
        });
      });

      document.addEventListener('fullscreenchange', function () {
        syncFullscreenButtons(wrap);
      });
      document.addEventListener('webkitfullscreenchange', function () {
        syncFullscreenButtons(wrap);
      });
    }
  }

  function mountFlipbook(wrap, bookEl, images, isPartial) {
    var PageFlip = getPageFlipClass();
    if (!PageFlip) throw new Error('pageflip_missing');
    if (!images || images.length < 1) throw new Error('no_pages');

    if (wrap.oleumPageFlip && wrap.oleumPageFlip.destroy) {
      wrap.oleumPageFlip.destroy();
      wrap.oleumPageFlip = null;
    }

    bookEl.innerHTML = '';

    var pageFlip = new PageFlip(bookEl, {
      width: 480,
      height: 640,
      size: 'stretch',
      minWidth: 260,
      maxWidth: 900,
      minHeight: 340,
      maxHeight: 820,
      maxShadowOpacity: 0.5,
      showCover: true,
      mobileScrollSupport: true,
      usePortrait: true,
      drawShadow: true,
      flippingTime: 650,
      useMouseEvents: true
    });

    wrap.oleumPageFlip = pageFlip;
    bindControls(wrap);

    pageFlip.on('flip', function () {
      updateStatus(wrap);
    });

    pageFlip.on('init', function () {
      showReady(wrap);
      updateStatus(wrap);
    });

    pageFlip.loadFromImages(images);

    if (!isPartial) {
      window.setTimeout(function () {
        showReady(wrap);
        updateStatus(wrap);
        if (pageFlip.update) pageFlip.update();
      }, 400);
    } else {
      showReady(wrap);
      updateStatus(wrap);
    }
  }

  function updateFlipbookImages(wrap, bookEl, images) {
    if (!wrap.oleumPageFlip) {
      mountFlipbook(wrap, bookEl, images, false);
      return;
    }

    if (wrap.oleumPageFlip.updateFromImages) {
      wrap.oleumPageFlip.updateFromImages(images);
    } else {
      wrap.oleumPageFlip.loadFromImages(images);
    }

    updateStatus(wrap);
    if (wrap.oleumPageFlip.update) wrap.oleumPageFlip.update();
  }

  function initFlipbook(root) {
    (root || document).querySelectorAll('[data-oleum-catalog-flipbook]').forEach(function (wrap) {
      if (wrap.dataset.catalogFlipbookReady === '1') return;
      if (wrap.dataset.catalogFlipbookLoading === '1') return;

      var pdfUrl = wrap.getAttribute('data-pdf-url');
      var bookEl = wrap.querySelector('[data-catalog-book]');
      if (!pdfUrl || !bookEl) return;

      wrap.dataset.catalogFlipbookLoading = '1';

      setVisible(wrap.querySelector('[data-catalog-loading]'), true);
      setVisible(wrap.querySelector('[data-catalog-shell]'), false);
      setVisible(wrap.querySelector('[data-catalog-error]'), false);

      waitForDeps(15000)
        .then(function () {
          var bootstrapped = false;
          var previewAt = 2;

          return loadPdfImagesProgressive(wrap, function (current, total, partial) {
            setLoadingMessage(
              wrap,
              total > 1
                ? 'Preparando el catálogo… (' + current + ' / ' + total + ')'
                : 'Preparando el catálogo…'
            );

            if (!bootstrapped && partial.length >= previewAt) {
              bootstrapped = true;
              mountFlipbook(wrap, bookEl, partial.slice(), true);
            }
          }).then(function (images) {
            if (!images || !images.length) throw new Error('no_pages');
            if (!bootstrapped) {
              mountFlipbook(wrap, bookEl, images, false);
            } else {
              updateFlipbookImages(wrap, bookEl, images);
            }
          });
        })
        .catch(function (err) {
          if (window.console && console.error) {
            console.error('[Oleum catalog]', err);
          }
          showError(wrap);
        });
    });
  }

  function boot() {
    initFlipbook(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFlipbook(event.target);
  });
})();
